import VyhlasenievZbierkeZakonovPage from './VyhlasenievZbierkeZakonovPage';

export default VyhlasenievZbierkeZakonovPage;
